import { Capacitor } from '@capacitor/core'
import { Router } from 'vue-router'
import { sentryBrowserInit } from './sentryBrowserInit'
import { sentryNativeInit } from './sentryNativeInit'

export type SentryInitParameters = { app: any; router: Router }
export const initSentry = (initParams: SentryInitParameters) => {
  if (process.env.NODE_ENV !== 'development') {
    console.log('sentry choose')
    if (Capacitor.isNativePlatform()) {
      console.log('sentry init native')
      //init native
      sentryNativeInit(initParams)
    } else {
      console.log('sentry init browser')
      // init browser-specific
      sentryBrowserInit(initParams)
    }
  }
}

export const processAPIEnv = (data: string) => {
  //todo change this, i'm just trying a quick fix here
  if (data.includes('-acceptance.network')) return 'acceptance'
  else if (data.includes('-staging.network')) return 'staging'
  else if (data.includes('-testing.network')) return 'testing'
  else if (data.includes('-qa.network')) return 'qa'
  else if (data.includes('neptune.networkninja')) return 'production'
  else return 'dev'
}

export const ignoreErrors = [
  'ResizeObserver loop limit exceeded', //this is safe to ignore
  'ResizeObserver loop completed with undelivered notifications.',
]
